import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/context/LanguageContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import Header from "@/components/Header";
import Preloader from "@/components/Preloader";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import ChatOrderFab from "@/components/ChatOrder";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Lookbook from "@/pages/Lookbook";
import ProductPage from "@/pages/ProductPage";
import About from "@/pages/About";
import Science from "@/pages/Science";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import OrderTrack from "@/pages/OrderTrack";
import Wishlist from "@/pages/Wishlist";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import ResetPassword from "@/pages/ResetPassword";
import LegalPage from "@/pages/LegalPage";
import Endurax from "@/pages/Endurax";
import NotFound from "@/pages/NotFound";
import { SeoLinks } from "@/components/SeoLinks";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <WishlistProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <SeoLinks />
          <div className="min-h-screen bg-white text-navy">
            <Preloader />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/lookbook" element={<Lookbook />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/science" element={<Science />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<Success />} />
                <Route path="/payment/cancel" element={<Cancel />} />
                <Route path="/track" element={<OrderTrack />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/account" element={<Account />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/legal/:page" element={<LegalPage />} />
                <Route path="/endurax" element={<Endurax />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <CartDrawer />
            <ChatOrderFab />
            <Toaster position="bottom-center" richColors />
          </div>
        </BrowserRouter>
        </WishlistProvider>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
